module.exports = __webpack_public_path__ + "assets/img/home-background.10de8e2e.svg";